import './FieldControlLayout.css';

import { cn } from '##/utils/bem';

export const cnFieldControlLayout = cn('FieldControlLayout');
